import React from 'react';
import { motion, Variants } from 'framer-motion';
import { useLandingTranslations } from '../contexts/LandingTranslationContext';

const fadeInUp: Variants = {
  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut" as const
    }
  }
};

const Members = () => {
  const { translations } = useLandingTranslations();

  return (
    <motion.section className="py-20 bg-[#F8F9FA]">
      <div className="container mx-auto px-8">
        <motion.h2 
          className="text-4xl font-bold text-center text-[#3D587D] mb-16"
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
        >
          {translations.members.title}
        </motion.h2>
        <div className="grid md:grid-cols-3 gap-8">
          {translations.members.stories.map((story, index) => (
            <motion.div
              key={index}
              className="bg-white p-6 rounded-xl shadow-lg"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              whileHover={{
                scale: 1.02,
                boxShadow: "0 20px 40px rgba(61, 88, 125, 0.1)"
              }}
            >
              <p className="text-[#407CBD] text-center font-semibold mb-2">{story.name}</p>
              <p className="text-sm text-[#3D587D] text-center mb-4">{story.role}</p>
              <p className="text-gray-600 text-center italic">"{story.quote}"</p>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default Members; 